import { MethodologyWithRoundDetails } from "@/types/Methodology";
import { useState } from "react";
import MethodologyReviewModal from "../reviewers/MethodologyReviewModal";
import Button from "../shared/ui/Button";

interface IProps {
	methodologyDetails: MethodologyWithRoundDetails;
}

const ApproveRejectMethodology = (props: IProps) => {
	const methodologyDetails = props.methodologyDetails;
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handelModalClose = () => {
		setIsModalOpen(false);
	};

	return (
		<>
			<Button variant="outline" className="mb-6 mr-4 w-64" onClick={() => setIsModalOpen(true)}>
				Approve/Reject
			</Button>
			{methodologyDetails.methodologyRoundId && (
				<MethodologyReviewModal
					isModalOpen={isModalOpen}
					handelModalClose={handelModalClose}
					methodologyRoundId={methodologyDetails.methodologyRoundId}
					canApprove={methodologyDetails.canApprove}
					canReject={methodologyDetails.canReject}
					status={methodologyDetails.status}
				/>
			)}
		</>
	);
};

export default ApproveRejectMethodology;
